import { ReactNode } from 'react';
import { LoaderSize, MixerLoader } from '../../Common/MixerLoader';

interface Props {
    condition: boolean;
    children: ReactNode;
    size?: LoaderSize;
}

export const MixerLoaderConditionWrapper = ({ condition, children, size = 'big' }: Props) => {
    return condition ? <>{children}</> : <MixerLoader size={size} position="centerOnParent" />;
};
